import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaPen, FaSignOutAlt } from 'react-icons/fa';
import './UserProfile.scss';
import { setUserInfo2 } from '../../reduxToolkit/redux';
import fnc from '../../mymod/commFunction';

const UserProfile = ({ user, onUpdateProfile, currentUser }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.reduxStore.userInfo);
  const userInfo2 = useSelector((state) => state.reduxStore.userInfo2); 
  const [isEditing, setIsEditing] = useState(false);

  // 디버깅: userInfo2 확인
  // React.useEffect(() => {
  //   console.log('[UserProfile] userInfo2:', userInfo2);
  //   console.log('[UserProfile] userInfo2.id:', userInfo2?.id);
  //   console.log('[UserProfile] userInfo2.id2:', userInfo2?.id2);
  // }, [userInfo2]);
  
  // 안전한 기본값 설정
  const getNickname = () => {
    return userInfo2?.nickname || '';
  };
  
  const getUserRealId = () => {
    return userInfo2?.id || '';
  }
  const getUserId2 = () => {//NAVER_100001
    return userInfo2?.id2 || userInfo2?.id || '아이디 없음';
  };
  
  const [editForm, setEditForm] = useState({
    id: getUserRealId(),//FAGNetz0mlRgBGTwyXpPYX5IlYW0JPcutteVO8o3zMc
    id2: getUserId2(),//NAVER_100001
    nickname: getNickname(),
  });

  // 프로필 수정 저장
  const handleSaveProfile = async (e) => {
    e.preventDefault();
    
    // 유효성 검사
    if (!editForm.nickname.trim()) {
      alert('닉네임을 입력해주세요.');
      return;
    }

    if (editForm.nickname.length < 2 || editForm.nickname.length > 15) {
      alert('닉네임은 2-15자 사이로 입력해주세요.');
      return;
    }


    try {
      // Firestore에 프로필 저장
      if (currentUser?.uid) {
        const { getFirestore, doc, updateDoc, serverTimestamp } = await import('firebase/firestore');
        const firestore = getFirestore();
        const userDocRef = doc(firestore, 'users', currentUser.uid);
        
        // undefined 값 제거한 업데이트 객체 생성
        const updateData = {
          nickname: editForm.nickname,  // Firebase도 nickname 필드 사용
          lastUpdated: serverTimestamp()
        };
        
        // userInfo2의 id 필드도 Firebase에 동기화
        if (editForm.id) {
          updateData.id = editForm.id;
        }
        
        // id2가 있을 경우에만 추가 (NAVER_100001 같은 값)
        if (editForm.id2) {
          updateData.id2 = editForm.id2;
        }
        
        await updateDoc(userDocRef, updateData);
      }

      // 프로필 업데이트 - 닉네임 업데이트

      fncUpdateNickname(editForm.id, editForm.nickname );

    } catch (error) {
      console.error('Error updating profile:', error);
      alert('프로필 업데이트에 실패했습니다.');
    }
  };

  // 수정 취소
  const handleCancelEdit = () => {
    setEditForm({
      nickname: getNickname(),
    });
    setIsEditing(false);
  };


  function fncUpdateNickname(id, nickname ) {

        fnc.sendAxios('/socialLoginRoutes/updateFirebaseNickname', { id, nickname }, (res) => {

            if (res.success && res.rowCount > 0) {      
                onUpdateProfile({
                  ...user,
                  nickname: editForm.nickname,
                });

                dispatch(setUserInfo2({
                  ...userInfo2,
                  nickname: editForm.nickname,
                }));
                
                setIsEditing(false);
                alert(`닉네임: ${editForm.nickname}으로 변경되었습니다!`);
            } else {
                alert('신청에 실패했습니다.');
            }
        });

  }

    // 온라인 상태 표시
  const getOnlineStatus = () => {
    return user?.isOnline ? 'online' : 'offline';
  };


  //============================================================================== 랜더링
  if (isEditing) {
    return (
      <div className="user-profile editing">
        <div className="profile-header">
          <h3>프로필 변경</h3>
        </div>
        
        <form className="profile-edit-form" onSubmit={handleSaveProfile}>
          <div className="profile-avatar-display">
            <div className="avatar-circle">
              <span>{editForm.name?.charAt(0)?.toUpperCase() || '?'}</span>
            </div>
          </div>


          <div className="form-group">
            <label htmlFor="name">닉네임</label>
            <input
              id="name"
              type="text"
              required
              value={editForm.nickname}
              onChange={(e) => setEditForm(prev => ({
                ...prev,
                nickname: e.target.value
              }))}
              placeholder="닉네임 입력"
              maxLength={15}
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn">
              저장
            </button>
            <button type="button" className="cancel-btn" onClick={handleCancelEdit}>
              취소
            </button>
          </div>
        </form>
      </div>
    );
  }

  //==============================================================================
  return (
    <div className="user-profile">
      <div className="profile-header">
        <h3>내 프로필</h3>
        <button 
          className="edit-btn"
          onClick={() => setIsEditing(true)}
          title="프로필 수정"
        >
          <FaPen size={12} />
        </button>
      </div>

      <div className="profile-info">
        <div className="profile-avatar">
          <div className="avatar-circle">
            {userInfo2.profile_image ? (
              // <img src={user.profileImage} alt="Profile" />
              <img src={userInfo2.profile_image} alt="Profile" />
            ) : (
              <span>{user?.name?.charAt(0)?.toUpperCase() || '?'}</span>
            )}
          </div>
          <div className={`online-status ${getOnlineStatus()}`}>
            <span className="status-dot"></span>
            <span className="status-text">
              {user?.isOnline ? '온라인' : '오프라인'}
            </span>
          </div>
        </div>

        <div className="profile-details">
          <div className="detail-item">
            <span className="label">닉네임 :</span>
            <span className="value">{getNickname()}</span>
          </div>

          <div className="detail-item">
            <span className="label">아이디 :</span>
            <span className="value user-id">
              {getUserId2()}
            </span>
          </div>
        </div>
      </div>

      {/* <div className="profile-stats">
        <div className="stat-item">
          <span className="stat-label">가입일</span>
          <span className="stat-value">
            {currentUser?.metadata?.creationTime ? 
              new Date(currentUser.metadata.creationTime).toLocaleDateString('ko-KR') : 
              '알 수 없음'
            }
          </span>
        </div>
        
        <div className="stat-item">
          <span className="stat-label">마지막 로그인</span>
          <span className="stat-value">
            {currentUser?.metadata?.lastSignInTime ? 
              new Date(currentUser.metadata.lastSignInTime).toLocaleDateString('ko-KR') : 
              '알 수 없음'
            }
          </span>
        </div>
      </div> */}

    </div>
  );
};

export default UserProfile;